export default __webpack_public_path__ + "static/media/145.ec1faae2.gif";